import { Button } from "@mui/material";
import React, { useState } from "react";
import ProfessionalInfoForm from "../../components/ProfessionalInfoCollection/ProfessionalInfoForm";

const TimelineHeader = () => {
  const [open, setOpen] = useState(false);
  return (
    <section className="relative w-full overflow-visible">
      {/* Header Content */}
      <div className="relative z-10 text-center py-6">
        <h1 className="font-inter text-[38px] leading-[100%] text-black font-bold mb-4">
          Your Roadmap To Success
        </h1>
        <p className="font-altis text-[20px] font-normal text-[#3F424C]">
          Just pick an interest to unlock your personalized timeline and
          discover career paths that fit you.
        </p>
        {/* <Button onClick={() => setOpen(true)}>TEST</Button>
        {open && <ProfessionalInfoForm onClose={() => setOpen(false)} />} */}
      </div>
    </section>
  );
};

export default TimelineHeader;
